<template>
  <div id="app">
    <div style="display: block;justify-content: center;align-items: center;">
      <img src="./assets/微信图片_20250527173948.png" style="width: 1600px;">
      <div style="text-align: center;">The hardware technical support is provided by Ningbo Core Mantle Electronic Technology Co., Ltd.</div>
      <!-- <div class="logo-and-info">
        <img src="./assets/logo.png" alt="Weihorizon Logo" class="logo">
        <div class="text-info">
          <h1>Weihorizon</h1>
          <p>A professional software platform for intelligent lighting systems</p>
          <div class="tabs">
            <span>Page</span>
            <span>Function</span>
          </div>
          <div class="contact-info">
            <p>Contact number: 19557472057</p>
            <p>Contact email: zwz@cmcore.com.cn</p>
          </div>
        </div>
      </div>
    </div>
    <div class="right-section">
      <div class="nav-item" v-for="(nav, index) in navItems" :key="index">
        <i :class="nav.iconClass" class="nav-icon"></i>
        <div class="nav-content">
          <h3>{{nav.title}}</h3>
          <div class="screenshot-container">
            <img :src="screenshot" alt="Screenshot" v-for="screenshot in nav.screenshots" :key="screenshot">
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        {
          title: 'Home',
          iconClass: 'fas fa-home',
          screenshots: [
            './assets/home-screenshot1.jpg',
            './assets/home-screenshot2.jpg'
          ]
        },
        {
          title: 'Equipment',
          iconClass: 'fas fa-microchip',
          screenshots: [
            './assets/equipment-screenshot1.png',
          ]
        },
        {
          title: 'Search',
          iconClass: 'fas fa-search',
          screenshots: [
            './assets/search-screenshot1.png'
          ]
        },
        {
          title: 'Settings',
          iconClass: 'fas fa-cog',
          screenshots: [
            './assets/settings-screenshot1.png',
            './assets/settings-screenshot2.png',
            './assets/settings-screenshot3.png',
            './assets/settings-screenshot4.png'
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
#app {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.left-section {
  width: 50%;
  display: flex;
  align-items: center;
}

.logo {
  width: 100px;
  height: 100px;
  margin-right: 20px;
}

.text-info {
  width: 70%;
}

.tabs span {
  margin-right: 10px;
  cursor: pointer;
}

.contact-info {
  margin-top: 20px;
}

.right-section {
  width: 45%;
  display: flex;
  flex-direction: column;
}

.nav-item {
  margin-bottom: 20px;
}

.nav-icon {
  font-size: 24px;
  margin-right: 10px;
  width: 30px;
  text-align: center;
}

.nav-content {
  display: flex;
  flex-direction: column;
}

.screenshot-container {
  display: flex;
  flex-wrap: wrap;
}

.screenshot-container img {
  width: 100px;
  height: 150px;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>